import update from 'immutability-helper';
import _ from 'lodash';
import { Action } from '../../redux.types';
import { PERMISSIONS_ACTION_NAMES } from '../permissions.actions';
import { ActiveRevisions, RawPermission } from '../permissions.types';

const defaultState: ActiveRevisions = {};

export const activeRevisions = (
  state: ActiveRevisions = defaultState,
  { type, payload }: Action,
): ActiveRevisions => {
  switch (type) {
    case PERMISSIONS_ACTION_NAMES.LOAD_PERMISSIONS_SUCCESS: {
      const activeRevisions = _.reduce(
        payload.responsePayload,
        (acc, permission: RawPermission) => {
          acc[permission.id] = permission.activeRevision.number;
          return acc;
        },
        {},
      );

      return {
        ...state,
        ...activeRevisions,
      };
    }

    case PERMISSIONS_ACTION_NAMES.CREATE_PERMISSION_SUCCESS: {
      const permission = payload.responsePayload;

      return update(state, {
        $merge: { [permission.id]: permission.activeRevision.number },
      });
    }

    case PERMISSIONS_ACTION_NAMES.ACTIVATE_REVISION_SUCCESS: {
      const { permissionId, revisionNumber } = payload.additionalData;
      return update(state, { $merge: { [permissionId]: revisionNumber } });
    }

    case PERMISSIONS_ACTION_NAMES.CREATE_REVISION_SUCCESS: {
      const { permissionId, activate } = payload.additionalData;
      const revision = payload.responsePayload;

      return update(state, {
        $merge: {
          [permissionId]: activate ? revision.number : state[permissionId],
        },
      });
    }

    default: {
      return state;
    }
  }
};
